package medicine.containers

import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.api.clients.MedicineApiClient
import com.jingfangpai.common.data.model.IdName
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.common.orm.mapping.Medicine
import com.jingfangpai.common.orm.mapping.enums.MedicineName
import com.jingfangpai.medicine.model.MedicineDetail
import medicine.components.MedicineInDetail
import react.*
import react.dom.div
import setTitle

external interface MedicineDetailPageProps : RProps {
    var id: String
}

data class MedicineDetailPageContextData(
    var getDetail: (id: String, okCallback: (result: ApiResponse<MedicineDetail>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getComments: (entityType: CommentEntityType, entityId: String, type: CommentType, okCallback: (result: ApiResponse<Array<Comment>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var saveComment: (comment: Comment, okCallback: (result: ApiResponse<Comment>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getRelatedPrescriptions: (medicineName: MedicineName, okCallback: (result: ApiResponse<List<IdName>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val MedicineDetailPageContext = createContext(MedicineDetailPageContextData(MedicineApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save, MedicineApiClient::getRelatedPrescriptions))

val MedicineDetailPageProvider = functionalComponent<MedicineDetailPageProps> { props ->

    setTitle("中药")

    useEffectOnce { }

    MedicineDetailPageContext.Provider(MedicineDetailPageContextData(MedicineApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save,MedicineApiClient::getRelatedPrescriptions)) {
        div("MedicineDetailPage-page") {
            child(MedicineInDetail) {
                attrs {
                    id = props.id
                }
            }
        }
    }
}
